import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React, { memo } from 'react'

interface StyleProps {
    isHidden: boolean
    calledFromImport?: boolean
}

const useShowHideBarStyles = makeStyles((theme: Theme) => ({
    paperNote: (props: StyleProps) => ({
        background: props.isHidden ? '#d9f3f940' : '#D9F3F9',
        border: 'none',
        marginLeft: props.calledFromImport
            ? theme.spacing(5)
            : theme.spacing(3),
        marginTop: theme.spacing(1.25),
        marginBottom: theme.spacing(1.25),
        marginRight: theme.spacing(17.625),
        padding: theme.spacing(2.25),
    }),
    note: (props: StyleProps) => ({
        color: props.isHidden ? '#04325B40' : '#04325B',
        fontSize: pxToRem(13),
        fontWeight: 400,
    }),
}))

export interface OfficeMasterNoteProps {
    isHidden: boolean
    calledFromImport?: boolean
    textContent: string
}

const OfficeMasterNote: React.FC<OfficeMasterNoteProps> = memo(
    ({ isHidden, calledFromImport, textContent }) => {
        const classes = useShowHideBarStyles({ isHidden, calledFromImport })
        return (
            <Paper className={classes.paperNote} variant="outlined">
                <GridContainer
                    direction={'column'}
                    spacing={2}
                    data-testid="officeMasterNote"
                >
                    <GridItem key={`officeMasterNote-${textContent}`}>
                        <Typography
                            component="span"
                            className={classes.note}
                            data-testid="actualMasterNote"
                        >
                            {textContent}
                        </Typography>
                    </GridItem>
                </GridContainer>
            </Paper>
        )
    }
)

export default OfficeMasterNote
